<template>
  <!-- Module -->
  <div class="module" :class="loading ? 'module--loading' : ''">
    <div class="module__media bg-dark-pink"></div>
    <div class="module__header">
      <h2>Search by course name or keyword</h2>
    </div>
    <div class="module__main">
      <!-- Search Form -->
      <!-- Search Input -->
      <fieldset>
        <cludo-vue-input class="form-control form-control--search" placeholder="Search...">
          <span class="sr-only">Search</span>
          <i class="icon-search" aria-hidden="true"></i>
        </cludo-vue-input>
      </fieldset>

      <!-- Collapse Toggle -->
      <button type="button" class="button button--small button--block button--toggle toggle toggle--m"
        aria-expanded="false" aria-controls="search-filters" data-toggle="true">
        Filter courses
        <span v-if="isFiltering" class="badge bg-white">{{
          filtersCount
        }}</span>
      </button>

      <!-- Collapse -->
      <div id="search-filters" class="collapse collapse--tablet-expanded">
        <div class="collapse__content">
          <!-- Search Checkboxes Filter: Study type -->
          <cludo-vue-check-boxes :options="[
            {
              label: 'Full-time study',
              name: 'full-time',
              field: 'StudyModes',
              value:
                'full-time only, full-time with part-time study available',
            },
            {
              label: 'Part-time study',
              name: 'part-time',
              field: 'StudyModes',
              value:
                'part-time only, full-time with part-time study available',
            },
          ]">
            <div class="filter-heading">
              <legend>Study type</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Search Checkboxes Filter: Year of entry -->
          <cludo-vue-check-boxes type="single" :options="yearOptions">
            <div class="filter-heading">
              <legend>Year of entry</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Search Checkboxes Filter: Study Options -->
          <cludo-vue-check-boxes :options="[
            {
              label: 'Study or work abroad',
              name: 'year-abroad',
              field: 'StudyOptions',
              value:
                'year_aboard, year_industry with year_aboard, year_aboard with open_international, year_industry with year_aboard with open_international',
            },
            {
              label: 'Year in industry',
              name: 'year-industry',
              field: 'StudyOptions',
              value:
                'year_industry, year_industry with year_aboard, year_industry with open_international, year_industry with year_aboard with open_international',
            },
            {
              label: 'Open to international students',
              name: 'open-international',
              field: 'StudyOptions',
              value:
                'open_international, year_aboard with open_international, year_industry with open_international, year_industry with year_aboard with open_international',
            },
          ]">
            <div class="filter-heading">
              <legend>Study options</legend>
            </div>
          </cludo-vue-check-boxes>
          
          <!-- Search Checboxes Filter: Faculty Options-->
          <!-- <cludo-vue-check-boxes
            :options="[
              {
                label: 'Arts',
                name: 'arts',
                field: 'Faculty',
                value: 'ARTS, Faculty of Arts',
              },
              {
                label: 'Engineering',
                name: 'engineering',
                field: 'Faculty',
                value: 'ENG',
              },
              {
                label: 'Health Sciences',
                name: 'health-sciences',
                field: 'Faculty',
                value: 'Faculty of Health Sciences, HLTH',
              },
              {
                label: 'Life Sciences',
                name: 'life-sciences',
                field: 'Faculty',
                value: 'LIFE',
              },
              {
                label: 'Science',
                name: 'science',
                field: 'Faculty',
                value: 'SCI',
              },
              {
                label: 'Social Sciences and Law',
                name: 'social-sciences-and-law',
                field: 'Faculty',
                value: 'SSL',
              },
            ]"
          >
            <div class="filter-heading">
              <legend>Faculty</legend>
            </div>
          </cludo-vue-check-boxes> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filterParamaters: {
      type: Object,
      default: () => { },
    },
    isFiltering: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    years: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    yearOptions() {
      // years arrive sorted highest first; the highest is checked by default
      return this.years.map((year, index) => ({
        label: `${year} Entry`,
        name: `${year}-entry`,
        field: 'StudyYear',
        value: year,
        ...(index === 0 && { checked: true }),
      }));
    },
    filtersCount() {
      const searchFilterCount =
        this.filterParamaters?.searchFilter?.length ?? 0;
      const sortFilterCount = this.filterParamaters?.sortFilter?.length ?? 0;
      const rangeFilterCount =
        Object.keys(this.filterParamaters?.rangeFilter)?.length ?? 0;
      const checkboxFilterCount =
        this.filterParamaters?.checkboxFilter.filter(
          (el) => el.checked === true
        ).length ?? 0;
      const count =
        searchFilterCount +
        sortFilterCount +
        rangeFilterCount +
        checkboxFilterCount;
      return count;
    },
  },
};
</script>

<style lang="scss">
.module {
  &__main {
    fieldset {
      padding: 0;
      border: none;
      width: 100%;
    }

    .form-control--input {

      input,
      label {
        cursor: pointer;
      }
    }
  }
}
</style>
